<template>
  <div class="wrap-adman-history">
    <Title
      main="A D M A N"
      des="HISTORY"
    />
    <div class="box-content">
      <p>
        Adman Awards & Symposium เป็นกิจกรรมซึ่งจัดขึ้นโดย สมาคมโฆษณาแห่งประเทศไทย ตั้งแต่ ปี พ.ศ. 2547 และได้ จัดอย่างต่อเนื่องเป็นประจำทุกปีจนปัจจุบันนี้ ซึ่งประกอบด้วยกิจกรรม 3 ส่วนด้วยกัน คือ งานประกวดผลงาน และงานมอบรางวัลแอดแมน อวอร์ส ตลอดจนงานสัมมนาเพื่อให้ความรู้แก่นักการตลาด นักโฆษณา และนิสิต/นักศึกษา ซึ่งเป็นการยกระดับมาตรฐานคุณภาพของธุรกิจการสื่อสารการตลาด
      </p>
      <h2>แอดแมน อวอร์ส คืออะไร</h2>
      <b-row>
        <b-col
          cols="12"
          lg="6"
        >
          แอดแมน อวอร์ส คือ การประกวดผลงานทางด้านการสื่อสารการตลาด อันเป็นกิจกรรมที่ส่งเสริมให้ทุกฝ่ายที่เกี่ยวข้องในธุรกิจ อุตสาหกรรม มีส่วนร่วมในกิจกรรมนี้เพื่อสนับสนุน ส่งเสริมยกย่องและให้กำลังใจ แก่องค์กร บุคลากรและผลงานที่มีคุณภาพ รับผิดชอบต่อจรรยาวิชาชีพ ซึ่งส่งผลให้ประชาชน องค์กรธุรกิจและสังคมเกิดการยอมรับ และเห็นถึง บทบาท ความสำคัญของการสื่อสารการตลาด
          <br><br>
          แอดแมน อวอร์ส มีความแตกต่างจากการประกวดผลงานด้าน โฆษณาอื่นๆ อย่างไร
          <br><br>
          แอดแมน อวอร์ส คือการประกวดผลงานด้านการสื่อสารการตลาด ครอบคลุม การสื่อสารในรูปแบบที่หลากหลาย ไม่เฉพาะโฆษณา แต่เป็นการประกวดที่รวม เอาผลงานด้านการประชาสัมพันธ์ กิจกรรมส่งเสริมการตลาด กราฟฟิคดีไซน์ และกลยุทธ์การใช้สื่อในรูปแบบใหม่ๆ เช่น สื่อดิจิทัล ตลอดจน นวัตกรรมความคิดสร้างสรรค์ใหม่ๆ เข้าร่วมประกวดในเวที แอดแมน อวอร์ส
          <br><br>
          แอดแมน อวอร์ส เป็นกิจกรรมที่ทุกฝ่ายที่เกี่ยวข้องในอุตสาหกรรมการสื่อสาร การตลาด ร่วมกันพัฒนา ยกระดับคุณภาพและมาตรฐานของอุตสาหกรรมให้ดียิ่งขึ้น ดังนั้น แอดแมน อวอร์ส จึงเป็นกิจกรรมที่เกิดขึ้นจากบุคลากรใน อุตสาหกรรมอย่างเเท้จริง
          <br><br>
          การตัดสินและคณะกรรมการตัดสิน มีโครงสร้างและการดำเนินการตัดสินที่แตกต่าง จากการประกวดที่เคยมีมา โดยเฉพาะกรรมการตัดสินที่ให้ความสำคัญกับความคิด สร้างสรรค์ที่ตอบโจทย์ทางการตลาดแบบครบวงจรที่ยอด เยี่ยมที่สุด และคณะกรรมการ เป็นผู้ทรงคุณวุฒิระดับมืออาชีพแถวหน้าของสาขาอาชีพต่างๆ ไม่ว่าจะเป็น นักโฆษณา นักประชาสัมพันธ์ นักการตลาด นักออกแบบกราฟฟิกดีไซน์ นักวางแผนกลยุทธ์มีเดีย ผู้เชี่ยวชาญทางด้านสื่อดิจิทัล ตลอดจนนักวิชาการจากสถาบันการศึกษาทั้งชาวไทย และต่างประเทศ
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
          ในปีที่ผ่านมา (พ.ศ. 2561) ทางสมาคมฯ ได้มีการพลิกโฉมรูปแบบการจัดงาน ด้วยความเชื่อที่ว่าความคิดสร้างสรรค์มีอยู่ทุกที่ ไม่ว่าใครก็สามารถใช้ความคิดสร้างสรรค์ได้ จึงเป็นปีแรกที่จัดให้มี “วันความคิดสร้างสรรค์แห่งชาติ (Creativity Day)” งานที่ไม่ใช่มีไว้เพื่อคนโฆษณาเพียงอย่างเดียวอีกต่อไป แต่จะเป็นงานเพื่อคนไทยทุกคนที่เชื่อในความคิดสร้างสรรค์ และเห็นคุณค่าของการใช้ความคิดสร้างสรรค์ในการสร้างความเปลี่ยนแปลง งานที่จะรวบรวมนวัตกรรมความคิดสร้างสรรค์ของคนไทยจากที่ต่างๆ เพื่อมาเฉลิมฉลองและสร้างแรงบันดาลใจให้กันและกัน งานที่เหล่าคนสร้างสรรค์จะมาแบ่งปันความรู้ แบ่งปันความคิดและสร้างแรงบันดาลใจ
          <br><br>
          ซึ่งปีที่ทางสมาคมฯ ได้จัดกิจกรรม สัมมนาหลากหลายจากวิทยากรชาวไทย และชาวต่างชาติ ทั้งใน และนอกวงการ รวมถึงนิทรรศการ และเปิดให้ผู้ที่สนใจเข้าร่วม และเรายังมีการมอบรางวัลพิเศษ “Creativity for Sharing (CS Awards)” ให้กับคนนอกวงการโฆษณาที่ใช้ความคิดสร้างสรรค์ที่มุ่งสร้างความเปลี่ยนแปลงและเกิดประโยชน์แก่สังคมอีกด้วย ซึ่งได้รับการตอบรับเป็นอย่างดี
          <br><br>
          เพื่อตอกย้ำในพลังของความคิดสร้างสรรค์ของคนไทย ทางสมาคมฯ ได้จัดให้มี “วันความคิดสร้างสรรค์แห่งชาติ (Creativity Day)” ต่อๆไป เพื่อเป็นการเฉลิมฉลอง และสร้างแรงบันดาลใจให้คนไทยทุกคน
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
const Title = () => import('./Parts/Title')

export default {
  components: {
    Title
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-adman-history {
  padding: 22px 0;

  .box-content {
    word-break: break-all;
    font-size: 1.5rem;
    line-height: 1.2;
    color: #9E9E9E;

    h2 {
      margin-top: 18px;
      font-size: 1.75rem;
      color: black;
    }
  }
}
</style>
